import PropTypes from 'prop-types'
import styles from './layout.module.scss'
import { Footer } from 'layout/footer'
import { CookiesPopup } from 'layout/cookiesPopup'
import { CabinClassProvider } from 'hooks/useCabinClass'

const Layout = ({ children, defaultClass }) => {
  return (
    <CabinClassProvider defaultClass={defaultClass}>
      <CookiesPopup />
      <div className={styles.layout}>
        <main className={styles.layout__main}>{children}</main>
        <Footer defaultClass={defaultClass} />
      </div>
    </CabinClassProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  defaultClass: PropTypes.string,
}

export { Layout }
